import { OrgSelector } from './OrgSelector';

export function Header() {
  return (
    <header className="shrink-0 flex items-center px-5 py-1.5 bg-white border-b border-slate-200">
      <div className="flex-1" />
      {/* Multi-org selector (A2F-244) — hidden when user has ≤1 orgs */}
      <OrgSelector />
    </header>
  );
}
